import { FUND_DONATE_BUTTON_LABEL } from "~/models/fund";
import { DonateButton } from "~/common/charity/DonateButton";

export const FundDonateButton = ({
  onClick,
}: {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    // only show the donate button
    <DonateButton
      label={FUND_DONATE_BUTTON_LABEL}
      size={"md"}
      enabled={true}
      loading={false}
      onClick={onClick}
    />
  );
};
